



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import Toast from '../services/toast';
import { RegexType } from '@/features/bots/models/designer/regexType';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import { MAX_INTEGER } from '../constants';

@Component({
	components: {
		EditIcon
	}
})
export default class EditableComponent extends Vue {
	@Prop() public value: any;
	@Prop() public fieldName: string;
	@Prop({ default : 'text' }) public type: string;
	@Prop({ default: 'unknown' }) public placeholder: string;
	@Prop() public options: string[];
	@Prop({ default: true }) public displayRelativeDate: boolean;
	@Prop({ default: false }) public displayIcon: boolean;

	public pattern: string = '.*';
	public maxLength: number = 100;
	public max: number = Infinity;
	public min: number = -Infinity;

	public valueToDisplay: any = '';
	public actualValue: any = '';
	public isEditing: boolean = false;
	public $refs: {
		inputField: any,
	};
	private updateDateTimer: number;

	public mounted() {
		 if (this.type === 'tel') {
			 this.pattern = RegexType.PHONE_NUMBER;
			 this.maxLength = 14;
		 } else if (this.type === 'number') {
			 this.max = MAX_INTEGER;
			 this.min = -MAX_INTEGER;
		 } else if (this.type === 'decimal') {
		 	  this.pattern = RegexType.DECIMAL;
		 	  this.maxLength = 28;
		 }
	}

	public beforeDestroy() {
		this.clearUpdateTimer();
	}

	@Watch('value', { immediate: true })
	public onValueChanged(value: any, prevValue: any) {
		if (!value) {
			this.valueToDisplay = '';
			this.actualValue = '';
		} else if (this.type === 'datetime-local') {
			this.setupDateTime(value);
		} else if (this.type === 'date') {
			if (value instanceof Date && moment(value).isSame(moment(prevValue), 'minute')) {
				return;
			}
			if (value instanceof Date) {
				this.actualValue = moment(value).format('YYYY-MM-DD');
			} else {
				this.actualValue = value;
			}
			this.valueToDisplay = this.getDateToDisplay();
			this.setUpdateDateTimer();
		} else {
			this.valueToDisplay = value;
			this.actualValue = value;
		}
	}

	public startEditing() {
		this.isEditing = true;

		this.$nextTick(() => {
			const el = this.$refs.inputField;
			el.focus();
		});
	}

	public finishEditing() {
		if (!this.$refs.inputField.checkValidity()) {
			Toast.showError(this.getErrorMessage());
			if (this.type === 'datetime-local') {
				if (!this.value) {
					this.valueToDisplay = '';
					this.actualValue = '';
					this.isEditing = false;
					return;
				}
				this.setupDateTime(this.value);
				this.isEditing = false;
			} else {
				this.actualValue = this.value;
			}
			return;
		}

		this.isEditing = false;
		if ((this.type === 'datetime-local' || this.type === 'date') && this.actualValue) {
			// Convert back to a Date object
			this.$emit('input', new Date(this.actualValue));
		} else {
			this.$emit('input', this.actualValue);
		}
	}

	private setupDateTime(value: Date) {
		this.valueToDisplay = this.getDateToDisplay();
		this.setActualValueFromDate(value);
		if (this.displayRelativeDate) {
			this.setUpdateDateTimer();
		}
	}

	private setActualValueFromDate(date: Date) {
		const dateAsIso = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
		if (this.dateHasSeconds(dateAsIso)) {
			this.actualValue = dateAsIso.substring(0, dateAsIso.lastIndexOf(':'));
		} else {
			this.actualValue = dateAsIso.substring(0, dateAsIso.length - 1); // remove zulu time from string
		}
	}

	private setUpdateDateTimer() {
		this.clearUpdateTimer();
		this.updateDateTimer = window.setInterval(() => this.valueToDisplay = this.formatRelativeDate(this.actualValue), 30000);
	}

	private clearUpdateTimer() {
		if (this.updateDateTimer) {
			window.clearInterval(this.updateDateTimer);
		}
	}

	private dateHasSeconds(value: string): boolean {
		return (value.match(/:/g) || []).length === 2;
	}

	private getErrorMessage() {
		if (this.fieldName) {
			return `${this.fieldName} is in an invalid format`;
		} else {
			return`${this.type} is in an invalid format`;
		}
	}

	private getDateToDisplay() {
		if (this.displayRelativeDate) {
			return this.formatRelativeDate(this.value);
		}
		return this.formatDate(this.value);
	}

	private formatRelativeDate(date: Date): string {
		if (!date) {
			return '';
		}
		return moment(date).fromNow();
	}

	private formatDate(date: Date) {
		return moment(date).format('DD/MM/YYYY HH:mm');
	}
}
